import { deviceTableDefaultColumns } from './device';
import { projectTableDefaultColumns } from './project';
import { userTableDefaultColumns } from './user';
import { shipmentTableDefaultColumns } from './shipment';
import { tableNameType } from '#type';

const defaultColumns = {
  [tableNameType.DEVICE_TABLE]: deviceTableDefaultColumns,
  [tableNameType.PROJECT_TABLE]: projectTableDefaultColumns,
  [tableNameType.USER_TABLE]: userTableDefaultColumns,
  [tableNameType.SHIPMENT_TABLE]: shipmentTableDefaultColumns
};

export default defaultColumns;
